module.exports = " \r\n<div id=\"overlay\">\r\n\t<div class=\"loader\"></div>\r\n</div>"